export const API_URL = process.env.REACT_APP_API;
//export const API_URL = process.env.REACT_APP_LOCAL_API;
export function numberFormat(x) {
	return x ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '';
}
